import { ChevronDown } from "lucide-react";
import type React from "react";
import type { DataFieldSelect } from "schema/agent";
import { Field } from "./Field";

export interface SelectFieldProps {
  field: DataFieldSelect;
  onChange: (value: string) => void;
}

export const SelectField: React.FC<SelectFieldProps> = ({ field, onChange }) => {
  return (
    <Field icon={ChevronDown} label={field.label} visibleAt={field.visibleAt}>
      <select
        value={field.value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full h-6 bg-slate-900/50 text-slate-300 text-xs px-2 rounded focus:outline-none focus:ring-1 focus:ring-indigo-500"
      >
        {field.options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </Field>
  );
};
